export default __webpack_public_path__ + "static/javascript_fullstack_online_bootcamp-a618fc9ebc1649c91e55d968ddb658f9.jpg";